import { useMutation } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

function useCreateClasse() {
  return useMutation(URL.SHARE.CRIAR, async (body: any) => {
    const response = await http.post(URL.CLASSES_OPERACAO.SALVAR, body);
    return response;
  });
}

export default useCreateClasse;
